export enum AssetStatusEnum {
     
    GRN = 'GRN',
    Idle = 'Idle',
    Running = 'Running',
    Undermaintenance = 'Undermaintenance',
    Damaged = 'Damaged',
    Retired = 'Retired',
    Inprogress = 'Inprogress',
    Completed = 'Completed',
    Intransit = 'Intransit',
    Service = 'Service',
    LocationMapped = 'LocationMapped',
    Sold = 'Sold'
}